module.exports = __webpack_public_path__ + "static/media/logo.807f07af.svg";